import { Injectable } from '@angular/core';
import { AbstractNavigationDataService, NavigationData, OverlayService } from '@finra/rampdi-forms-common';
import { environment } from '../../environments/environment';
import { ActivatedRouteSnapshot } from '@angular/router';
import { InstanceService } from './instance.service';
import { DisplayRulesService } from './display-rules.service';

export const FORM_TYPES = {
  INITIAL: 'INITIAL',
};

// Version 0.0.1 navigation with single disclosure page
const navView_v001: NavigationData[] = [
  {
    type: 'header',
    id: 'dataEntry',
    text: environment.formName,
    skip: true,
    children: [
      {
        id: 'branchInformation',
        text: 'Branch Information',
        skip: true,
        expanded: true,
        children: [
          {
            id: 'identifyingInformation',
            text: 'Identifying Information',
            modelPath: [],
            pointerList: [/^#\/identifyingInformation/],
          },
          {
            id: 'webAddresses',
            text: 'Web Addresses',
            modelPath: ['webAddresses'],
            pointerList: [/^#\/webAddresses/],
          },
          // @mu3-todo(pending-section): Uncomment when Other Trade Names layout/schema is implemented
          // {
          //   id: 'otherTradeNames',
          //   text: 'Other Trade Names',
          //   modelPath: ['otherTradeNames'],
          //   pointerList: [/^#\/otherTradeNames/],
          // },
        ],
      },
      // @mu3-todo(pending-section): Uncomment when Points of Contact layout/schema is implemented
      // {
      //   id: 'pointsOfContact',
      //   text: 'Points of Contact',
      //   skip: true,
      //   expanded: true,
      //   children: [
      //     {
      //       id: 'branchManagers',
      //       text: 'Branch Manager(s)',
      //       modelPath: ['branchManagers'],
      //       pointerList: [/^#\/branchManagers/],
      //     },
      //   ],
      // },
      {
        id: 'operationInformation',
        text: 'Operation and Expense Information',
        modelPath: [],
        pointerList: [/^#\/operationInformation/, /^#\/expenseInformation/],
      },
      {
        id: 'attestAndSubmit',
        text: 'Attest and Submit',
        modelPath: [],
        pointerList: [/^#\/attestAndSubmit/],
      },
    ],
  },
];

const formView_v001: NavigationData[] = [
  {
    id: 'formView',
    type: 'header',
    text: 'Form View',
    skip: true,
    children: [
      {
        id: 'formViewIdentifyingInformation',
        text: 'Identifying Information',
        modelPath: [],
        pointerList: [/^#\/identifyingInformation/],
      },
      {
        id: 'formViewWebAddresses',
        text: 'Web Addresses',
        modelPath: [],
        pointerList: [/^#\/webAddresses/],
      },
      // @mu3-todo(pending-section): Uncomment when Other Trade Names layout/schema is implemented
      // {
      //   id: 'formViewOtherTradeNames',
      //   text: 'Other Trade Names',
      //   modelPath: ['otherTradeNames'],
      //   pointerList: [/^#\/otherTradeNames/],
      // },
      // @mu3-todo(pending-section): Uncomment when Branch Manager(s) layout/schema is implemented
      // {
      //   id: 'formViewBranchManagers',
      //   text: 'Branch Manager(s)',
      //   modelPath: ['branchManagers'],
      //   pointerList: [/^#\/branchManagers/],
      // },
      {
        id: 'formViewOperationInformation',
        text: 'Operation and Expense Information',
        modelPath: [],
        pointerList: [/^#\/operationInformation/, /^#\/expenseInformation/],
      },
      {
        id: 'all',
        text: 'All Sections',
        modelPath: [],
      },
    ],
  },
];

const navView: NavigationData[] = [
  {
    type: 'header',
    id: 'dataEntry',
    text: environment.formName,
    skip: true,
    children: [
      {
        id: 'branchInformation',
        text: 'Branch Information',
        skip: true,
        expanded: true,
        children: [
          {
            id: 'identifyingInformation',
            text: 'Identifying Information',
            modelPath: [],
            pointerList: [/^#\/identifyingInformation/],
          },
          {
            id: 'webAddresses',
            text: 'Web Addresses',
            modelPath: ['webAddresses'],
            pointerList: [/^#\/webAddresses/],
          },
          // @mu3-todo(pending-section): Uncomment when Other Trade Names layout/schema is implemented
          // {
          //   id: 'otherTradeNames',
          //   text: 'Other Trade Names',
          //   modelPath: ['otherTradeNames'],
          //   pointerList: [/^#\/otherTradeNames/],
          // },
        ],
      },
      // @mu3-todo(pending-section): Uncomment when Points of Contact layout/schema is implemented
      // {
      //   id: 'pointsOfContact',
      //   text: 'Points of Contact',
      //   skip: true,
      //   expanded: true,
      //   children: [
      //     {
      //       id: 'branchManagers',
      //       text: 'Branch Manager(s)',
      //       modelPath: ['branchManagers'],
      //       pointerList: [/^#\/branchManagers/],
      //     },
      //   ],
      // },
      {
        id: 'operationInformation',
        text: 'Operation and Expense Information',
        modelPath: [],
        pointerList: [/^#\/operationInformation/, /^#\/expenseInformation/],
      },
      {
        id: 'attestAndSubmit',
        text: 'Attest and Submit',
        modelPath: [],
        pointerList: [/^#\/attestAndSubmit/],
      },
    ],
  },
];

const formView: NavigationData[] = [
  {
    id: 'formView',
    type: 'header',
    text: 'Form View',
    skip: true,
    children: [
      {
        id: 'formViewIdentifyingInformation',
        text: 'Identifying Information',
        modelPath: [],
        pointerList: [/^#\/identifyingInformation/],
      },
      {
        id: 'formViewWebAddresses',
        text: 'Web Addresses',
        modelPath: [],
        pointerList: [/^#\/webAddresses/],
      },
      // @mu3-todo(pending-section): Uncomment when Other Trade Names layout/schema is implemented
      // {
      //   id: 'formViewOtherTradeNames',
      //   text: 'Other Trade Names',
      //   modelPath: ['otherTradeNames'],
      //   pointerList: [/^#\/otherTradeNames/],
      // },
      // @mu3-todo(pending-section): Uncomment when Branch Manager(s) layout/schema is implemented
      // {
      //   id: 'formViewBranchManagers',
      //   text: 'Branch Manager(s)',
      //   modelPath: ['branchManagers'],
      //   pointerList: [/^#\/branchManagers/],
      // },
      {
        id: 'formViewOperationInformation',
        text: 'Operation and Expense Information',
        modelPath: [],
        pointerList: [/^#\/operationInformation/, /^#\/expenseInformation/],
      },
      {
        id: 'all',
        text: 'All Sections',
        modelPath: [],
      },
    ],
  },
];

@Injectable({
  providedIn: 'root',
})
export class NavigationDataService extends AbstractNavigationDataService {
  constructor(
    public OS: OverlayService,
    private DS: DisplayRulesService,
    private IS: InstanceService,
  ) {
    super({
      dataEntry: {
        [FORM_TYPES.INITIAL]: navView,
      },
      formView: {
        [FORM_TYPES.INITIAL]: formView,
      },
    });
  }

  // Override getNavData to handle version-specific navigation
  getNavData(key: string): any[] {
    const templateVersion = this.IS.currentInstance?.templateVersion;

    if (templateVersion === '0.0.1') {
      const [viewType] = key.split('.');
      return viewType === 'formView' ? [...formView_v001] : [...navView_v001];
    }

    // Normalize filingTypeCode to INITIAL — this app only has one form type
    const [viewType] = key.split('.');
    const normalizedKey = `${viewType}.${FORM_TYPES.INITIAL}`;
    return super.getNavData(normalizedKey);
  }

  // Override getNavItem to handle version-specific navigation
  getNavItem(key: string, navId: string): NavigationData | null {
    const templateVersion = this.IS.currentInstance?.templateVersion;

    if (templateVersion === '0.0.1') {
      const [viewType] = key.split('.');
      const navData = viewType === 'formView' ? formView_v001 : navView_v001;
      return this.findNavItemRecursive(navData, navId);
    }

    // Normalize filingTypeCode to INITIAL -- this app only has one form type
    // so any filingTypeCode (e.g., MU3) from instance metadata maps to INITIAL
    const [viewType] = key.split('.');
    const normalizedKey = `${viewType}.${FORM_TYPES.INITIAL}`;
    return super.getNavItem(normalizedKey, navId);
  }

  /**
   * Recursively searches nav data tree for a node matching the given id.
   * Handles arbitrary nesting depth (collapsible groups within groups).
   */
  private findNavItemRecursive(nodes: NavigationData[], navId: string): NavigationData | null {
    for (const node of nodes) {
      if (node.id === navId) return node;
      if (node.children) {
        const found = this.findNavItemRecursive(node.children, navId);
        if (found) return found;
      }
    }
    return null;
  }

  resolve(route: ActivatedRouteSnapshot) {
    const { instance } = route.parent.data.instanceData;
    const filingType = instance?.instanceMetadata?.attributes?.filingTypeCode;
    const templateVersion = instance?.templateVersion;

    // Use version-specific navigation for 0.0.1 (single disclosure page)
    let navData;
    if (templateVersion === '0.0.1') {
      const viewType = route.params.viewType;
      navData = viewType === 'formView' ? [...formView_v001] : [...navView_v001];
    } else {
      navData = this.getNavData(`${route.params.viewType}.${filingType}`);
    }

    // Hide "Attest and Submit" menu item for processed filings
    const currentRules = this.DS.getCurrentDisplayRules();
    const instanceStatus = currentRules?.displayedStatus;
    if (instanceStatus === 'Filing Processed' || instanceStatus === 'Failed Processing') {
      navData.forEach((nav) => {
        if (nav.children) {
          nav.children = nav.children.filter((child) => child.id !== 'attestAndSubmit');
        }
      });
    }

    const navId = route.params.sectionId + (route.params.licenseTypeCode ? `;${route.params.licenseTypeCode}` : '');

    this.removeActiveAll(navData);
    this.setActiveStatus(navData, navId, true);

    return navData;
  }

  closeSnackbar(): void {
    // Close any active snackbar directly instead of creating a new empty one
    if (this.OS.activeToastInstance) {
      this.OS.activeToastInstance.close();
    }
  }
}
